import React, { useState } from "react";
import StudioFilter from "../../../../app/core/components/UserFilter/StudioFilter";
import {
  useAddStudioGroupMutation,
  useGetGroupIdQuery,
  useGetStudiosQuery,
  useRemoveStudioGroupMutation,
} from "../../../api/admin/gestisciStudioApi";
import { TABLE_ROWS_NUMBER } from "../../../../utils/constants/tables";
import CoreChip from "../../../../app/core/components/CoreChip/CoreChip";
import { toast } from "react-toastify";
import { t } from "i18next";
import { useEffect } from "react";
import { IconButton, Tooltip } from "@mui/material";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";

const SettingsGroup = ({ groupId }) => {
  const [studio, setStudio] = useState();
  const [group, setGroup] = useState();
  const [debouncedInputStudioValue, setDebouncedInputStudioValue] =
    useState("");
  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });

  const { data: dataList } = useGetStudiosQuery({
    ...page,
  });

  const { data: dataSearch, isLoading: loadingSearch } = useGetStudiosQuery({
    ...page,
    value: debouncedInputStudioValue,
  });

  const { data: groupData, refetch } = useGetGroupIdQuery(groupId, {
    skip: !groupId,
  });

  const [removeStudio] = useRemoveStudioGroupMutation();
  const [addStudio] = useAddStudioGroupMutation();

  const labelStudioForGroup = (v, studios) => {
    if (!studios || !studios.items) return "";
    const studio = studios?.items?.find((studio) => studio.id === v.studioId);
    return studio ? studio.name : "";
  };

  useEffect(() => {
    if (groupData) {
      setGroup(groupData.Data);
    }
  }, [groupData]);

  const handleRemoveStudio = (studioId) => {
    removeStudio({
      studioId: studioId,
      groupId: group.id,
    }).then((res) => {
      if (res?.data?.Result !== 1) {
        toast.error(t("NotRemovedStudioGroup"));
        return;
      }
      toast.success(t("RemovedStudioGroup"));
      refetch();
    });
  };

  const handleAddStudio = (el) => {
    addStudio({
      studioId: el.id,
      groupId: group.id,
    }).then((res) => {
      if (res?.data?.Result !== 1) {
        toast.error(t("NotAddStudioGroup"));
        return;
      }
      toast.success(t("AddStudioGroup"));
      refetch();
    });
  };

  const filterStudios = dataSearch?.Data?.items.filter(
    (el) => !group?.studios?.map((v) => v.studioId).includes(el.id)
  );

  return (
    <div className="flex flex-col justify-center items-center">
      <h3>{t("MangeGroup")}</h3>
      <div className=" flex items-center w-2/3 space-x-4">
        <StudioFilter
          selectedUser={studio}
          setSelectedUser={setStudio}
          usersList={filterStudios}
          setDebouncedInputUserValue={setDebouncedInputStudioValue}
          isUsersLoading={loadingSearch}
        />

        <Tooltip title={t("Add")}>
          <IconButton
            className={studio ? "text-green-600" : "text-gray-300"}
            disabled={!studio}
            variant="outlined"
            onClick={() => handleAddStudio(studio)}
          >
            <AddCircleOutlineRoundedIcon />
          </IconButton>
        </Tooltip>
      </div>

      <div
        className="mt-8 p-4 space-x-1 overflow-y-scroll h-[19rem] w-2/3 "
        style={{
          border: "1px solid lightgrey",
        }}
      >
        {group?.studios?.length > 0 ? (
          group?.studios?.map(
            (v, index) =>
              v !== "" && (
                <CoreChip
                  className="mt-2"
                  key={index}
                  label={labelStudioForGroup(v, dataList?.Data)}
                  variant="outlined"
                  onDelete={() => handleRemoveStudio(v.studioId)}
                />
              )
          )
        ) : (
          <p className="text-gray h-full flex justify-center items-center m-0">
            {t("NoStudioGroup")}
          </p>
        )}
      </div>
    </div>
  );
};

export default SettingsGroup;
